export default __webpack_public_path__ + "static/media/triatlon.0b19025b.svg";